import React from 'react'
export default class StepFinishStatus extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {message, statusClass} = this.props;

    return (
      <div className={statusClass} dangerouslySetInnerHTML={{ __html: message }}></div>  
    )
  }
}
